import React from 'react'
import { Button } from 'reactstrap';
import { FormModalDiscountTest } from './FormModalDiscountTest';
import { Dialog } from 'primereact/dialog';

export const ModalDiscountTest = (props) => {
    const {
        modal, closeDialog, loading, method, handleInputChange, enable_discounts, currentExam, handleSaveDiscount
    } = props;

    if (method !== "update") return null;

    return (
        <Dialog
            // header={currentExam?.id_profile ? 'Perfil con descuento' : 'Exámen con descuento'}
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            blockScroll
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-tags"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {currentExam?.id_profile ? 'Perfil con descuento' : 'Exámen con descuento'}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}
            footer={
                <>
                    <Button
                        color="secondary"
                        size="sm"
                        onClick={handleSaveDiscount}
                    >
                        {
                            loading ? "Guardando..." : "Guardar"
                        }

                    </Button>
                    <Button
                        size="sm"
                        className="btn-air-light"
                        color="danger"
                        type="button"
                        onClick={closeDialog}
                    >
                        Cancelar
                    </Button>

                </>
            }

        >

            <FormModalDiscountTest
                button="Exámen con descuento"
                {...{
                    closeDialog,
                    loading,
                    modal,
                    method,
                    handleInputChange,
                    enable_discounts,
                    currentExam,
                    handleSaveDiscount,
                    methodAction: handleSaveDiscount
                }}
            />
        </Dialog>
    );
};
